import React from "react";
import { Receipt, Mail, Phone, ArrowLeft, CheckCircle2, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export default function Refund() {
  return (
    <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh", paddingBottom: "80px" }}>
      {/* Clean White Header Banner */}
      <div
        style={{
          background: "#ffffff",
          color: "#0f172a",
          padding: "120px 0 50px 0",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <div className="container">
          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              color: "#64748b",
              fontSize: "0.9rem",
              fontWeight: 600,
              textDecoration: "none",
              marginBottom: "20px",
            }}
          >
            <ArrowLeft size={16} /> Back to EMIBOOK Home
          </Link>

          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "12px" }}>
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                background: "rgba(37, 99, 235, 0.1)",
                color: "#2563eb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Receipt size={24} />
            </div>
            <h1
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "clamp(1.8rem, 3.5vw, 2.6rem)",
                fontWeight: 800,
                color: "#0f172a",
                margin: 0,
              }}
            >
              Pricing & Refund Policy
            </h1>
          </div>
          <p style={{ color: "#64748b", fontSize: "1.05rem", maxWidth: "680px", margin: 0 }}>
            Transparent terms regarding our subscription plans, 7-day satisfaction window, and refund processing timeline.
          </p>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="container" style={{ marginTop: "40px" }}>
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div
              className="white-card"
              style={{
                borderRadius: "24px",
                padding: "40px",
                color: "#334155",
                lineHeight: 1.75,
              }}
            >
              <div
                style={{
                  background: "#ecfdf5",
                  border: "1px solid #a7f3d0",
                  borderRadius: "16px",
                  padding: "20px 24px",
                  marginBottom: "32px",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "14px",
                }}
              >
                <Clock size={24} color="#059669" style={{ flexShrink: 0, marginTop: "2px" }} />
                <div>
                  <h4 style={{ color: "#065f46", fontSize: "1.1rem", fontWeight: 800, margin: 0 }}>
                    7-Day Money-Back Period
                  </h4>
                  <p style={{ color: "#047857", fontSize: "0.92rem", margin: "4px 0 0 0" }}>
                    We offer full refunds on product subscriptions within 7 days of the purchase date for registered subscribers.
                  </p>
                </div>
              </div>

              <section style={{ marginBottom: "28px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  1. Policy Overview
                </h3>
                <p>
                  At EMIBOOK, we strive to ensure complete customer satisfaction with every subscription. We understand that sometimes a product may not meet your operational expectations. Therefore, we offer refunds under clear and transparent terms.
                </p>
              </section>

              <section style={{ marginBottom: "28px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  2. Eligibility Requirements
                </h3>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <CheckCircle2 size={18} color="#2563eb" />
                    <span><strong>Registered User:</strong> You must be an active registered subscriber of EMIBOOK.</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <CheckCircle2 size={18} color="#2563eb" />
                    <span><strong>Timeframe:</strong> The refund request must be initiated within 7 calendar days of payment.</span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <CheckCircle2 size={18} color="#2563eb" />
                    <span><strong>Proof of Purchase:</strong> A receipt or digital transaction proof must accompany the request.</span>
                  </div>
                </div>
              </section>

              <section style={{ marginBottom: "28px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  3. Refund Processing Timeline
                </h3>
                <p>
                  Once your return/refund request is received, our team will send an email acknowledgment. A credit will automatically be applied to your original method of payment within <strong>TWO (2) working days</strong> after the acknowledgment email is sent.
                </p>
              </section>

              <section style={{ marginBottom: "28px" }}>
                <h3 style={{ fontFamily: "var(--font-display)", color: "#0f172a", fontSize: "1.35rem", fontWeight: 800, marginBottom: "12px" }}>
                  4. How to Initiate a Refund
                </h3>
                <p>
                  If you wish to initiate a refund or have any questions regarding your account, please contact our customer service team directly:
                </p>

                <div
                  style={{
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                    borderRadius: "16px",
                    padding: "20px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Mail size={18} color="#2563eb" />
                    <span><strong>Email:</strong> <a href="mailto:support@emibook.in" style={{ color: "#2563eb" }}>support@emibook.in</a></span>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Phone size={18} color="#2563eb" />
                    <span><strong>Phone:</strong> <a href="tel:9036770772" style={{ color: "#2563eb" }}>+91 9036770772</a></span>
                  </div>
                  <div>
                    <strong>Operating Entity:</strong> S R R Enterprise
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
